import React, { useState } from 'react'
import { 
    BottomNavigation as BottomNavMui,
    BottomNavigationAction,
    Paper,
} from '@mui/material';

import ContactPageIcon from '@mui/icons-material/ContactPage';
import BuildIcon from '@mui/icons-material/Build';
import SendIcon from '@mui/icons-material/Send';
import BarChartIcon from '@mui/icons-material/BarChart';

import { useHistory } from 'react-router-dom';

const BottomNavigation = ({ isAdmin })=>{
    const [value, setValue] = useState(0);
    // Usando o history
    const history = useHistory();
    const fnRota = rota=> history.push(rota);
    //
    const menu = [
        {icone: <ContactPageIcon />, texto: 'Curriculos', url: '/curriculo', titulo: 'Navegue até os curriculos'},
        {icone: <BarChartIcon />, texto: 'Estatisticas', url: '/curriculo_estatisticas', titulo: 'Visualize graficos e informações estatisticas'},
    ];
    // Se for um usuario admin entao devemos permitir o usuario de manipular os outros usuarios
    if(isAdmin){
        menu.push(
            {icone: <BuildIcon />, texto: 'Manutenção', url: '/manutencao', titulo: 'Navegue até a area de manutencao'}
        );
        // Determina a parte para edição das mensagens, tanto do termo aceite quanto do WhatsApp
        menu.push(
            {icone: <SendIcon />, texto: 'Mensagens', url: '/cadastro_mensagens', titulo: 'Altere mensagens do whatsApp ou termo aceite'}
        )
    }
    
    return (
        <Paper sx={{width: '100vw', position: 'fixed', bottom: 0}} >
            <BottomNavMui showLabels 
             value={value}
             onChange={ (evt, value)=> setValue(value) }
            >
                {menu.map((ele,idx)=>(
                    <BottomNavigationAction key={idx}
                        icon={ele.icone} label={ele.texto} 
                        onClick={()=> fnRota(ele.url) }
                    />
                ))}
            </BottomNavMui>
        </Paper>
        
    )
}

export default BottomNavigation;